import { render, staticRenderFns } from "./suitch-bridge-widget.vue?vue&type=template&id=216467ba&scoped=true&"
import script from "./suitch-bridge-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-bridge-widget.vue?vue&type=script&lang=js&"
import style0 from "./suitch-bridge-widget.vue?vue&type=style&index=0&id=216467ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216467ba",
  null
  
)

export default component.exports